<div class="quill-wrapper">
  <quill-editor #editor [formControl]="control" *ngIf="isEditor" (onContentChanged)="onContentChanged($event)" [placeholder]="placeholder">
  </quill-editor>
  <div [innerHTML]="content" *ngIf="!isEditor" class="client-styling"></div>
</div>
